import { AnimatePresence, motion } from 'framer-motion';
import AnimatedAtaric from '../shared/AnimatedAtaric';
import './celebration.css';

interface CelebrationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
  messagesThisSession: number;
  totalMessages: number;
}

function CelebrationModal({ isOpen, onClose, onExit, messagesThisSession, totalMessages }: CelebrationModalProps) {
  const celebrations = [
    'Incrível!',
    'Mandou bem!',
    'Excelente!',
    'Fantástico!',
    'Arrasou!',
    'Muito bom!',
  ];

  // Pick a random celebration
  const celebrationText = celebrations[Math.floor(Math.random() * celebrations.length)];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          className="celebration-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div 
            className="celebration-modal"
            initial={{ scale: 0.5, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.5, opacity: 0, y: 50 }}
            transition={{ type: "spring", damping: 15 }}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
          >
            {/* Ataric Pet Celebrating */}
            <div className="celebration-pet">
              <AnimatedAtaric size="large" behavior="celebrate" autoAnimate={false} context="celebration" />
              <span className="celebration-sparkle s1">✨</span>
              <span className="celebration-sparkle s2">⭐</span>
              <span className="celebration-sparkle s3">🎉</span>
              <span className="celebration-sparkle s4">✨</span>
            </div>
            
            <h2 className="celebration-title">{celebrationText}</h2>
            
            <p className="celebration-message">
              Você praticou <strong>{messagesThisSession}</strong> {messagesThisSession === 1 ? 'mensagem' : 'mensagens'} agora!
            </p>

            {totalMessages > 0 && (
              <motion.div 
                className="celebration-total"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                <span className="celebration-total-number">{totalMessages}</span>
                <span className="celebration-total-label">mensagens no total</span>
              </motion.div>
            )}

            <div className="celebration-actions">
              <button className="celebration-btn-primary" onClick={onClose}>
                Continuar praticando
              </button>
              <button className="celebration-btn-secondary" onClick={onExit}>
                Voltar
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default CelebrationModal;
